/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Subtitle_Extract_Done_ToastInputs */



/**
* | output |
* | --- |
* | "Event Groups imported: {count}" |
*
* @param {Subtitle_Extract_Done_ToastInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const subtitle_extract_done_toast = /** @type {((inputs: Subtitle_Extract_Done_ToastInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Subtitle_Extract_Done_ToastInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Groupes d'événements importés : ${i?.count}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Importierte Ereignisgruppen: ${i?.count}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Gruppi di eventi importati: ${i?.count}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Импортированные группы событий: ${i?.count}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Grupos de eventos importados: ${i?.count}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`已导入事件组：${i?.count}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`インポートされたイベントグループ: ${i?.count}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`आयातित इवेंट समूह: ${i?.count}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Grupos de eventos importados: ${i?.count}`)
	return /** @type {LocalizedString} */ (`Event Groups imported: ${i?.count}`)
});